import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { detect } from 'detect-browser';
// import { DeviceDetectorService } from 'ngx-device-detector';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  browser: string;
  browserVersion: string;

  constructor(
    // private deviceService: DeviceDetectorService
  ) {
   
  }
  epicFunction() {
    // this.browser = this.deviceService.getDeviceInfo().browser;
    // this.browserVersion = parseInt(this.deviceService.getDeviceInfo().browser_version, 10);
    const browser = detect();
    if (browser) {
      this.browser = browser.name;
      this.browserVersion = browser.version
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.epicFunction();
    if (localStorage.getItem('token')) {
      if (this.browser === 'ie') {
        if (req.headers.has(InterceptorSkipHeader)) {
          const headers = req.headers.delete(InterceptorSkipHeader);
          return next.handle(req.clone({ headers }));
        } else {
          const accessReq = req.clone({
            headers: req.headers.set('Cache-Control', 'no-cache')
              .set('Pragma', 'no-cache')
              .set('x-access-token', localStorage.getItem('token')).set('Content-Type', 'application/json')
          });
          return next.handle(accessReq);
        }

      } else {
        if (req.headers.has(InterceptorSkipHeader)) {
          const headers = req.headers.delete(InterceptorSkipHeader);
          return next.handle(req.clone({ headers }));
        } else {
          const accessReq = req.clone({
            headers: req.headers.set('x-access-token', localStorage.getItem('token')).set('Content-Type', 'application/json')
          });
          return next.handle(accessReq);
        }
      }
    } else {
      return next.handle(req);
    }
  }
}
